export { authorizationPlugin } from './authorization.plugin'
